import { render, staticRenderFns } from "./LinkCol.vue?vue&type=template&id=c7d02e64"
import script from "./LinkCol.vue?vue&type=script&lang=js"
export * from "./LinkCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports